import { render, staticRenderFns } from "./CourseCardPhrase.vue?vue&type=template&id=7611506e&scoped=true"
import script from "./CourseCardPhrase.vue?vue&type=script&lang=js"
export * from "./CourseCardPhrase.vue?vue&type=script&lang=js"
import style0 from "./CourseCardPhrase.vue?vue&type=style&index=0&id=7611506e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611506e",
  null
  
)

export default component.exports